import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UtilsService {
    /**
     * Given an array and a predicate which returns a Promise<boolean>, returns Promise<true>
     * if an element in the array satisfies the predicate. Returns Promise<false> otherwise.
     */
    public static async asyncSome(arr, predicate) {
        for (const e of arr) {
            if (await predicate(e)) return true;
        }
        return false;
    }

    public static unique(value, index, array) {
        return array.indexOf(value) === index;
    }

    public static isNullOrWhitespace(input: string): boolean {
        return !input || !input.trim();
    }

    public static enforceMinMax(el) {
        if (el.value != "") {
            if (Number.parseInt(el.value) < Number.parseInt(el.min)) {
                el.value = el.min;
            }
            if (Number.parseInt(el.value) > Number.parseInt(el.max)) {
                el.value = el.max;
            }
        }
    }

    public static objectIsEmpty(obj: object): boolean {
        return Object.keys(obj).length === 0;
    }

    public static foldDiacritics(text: string, locale?: string): string {
        const input = (text ?? "").toString();
        let out = input.toLocaleLowerCase(locale);

        out = out
            .replaceAll(/\u00A0|\u202F|\u2007/g, " ")
            .replaceAll(/[\u2019\u2018\u2032]/g, "'")
            .replaceAll(/[\u2013\u2014\u2212]/g, "-");

        if (locale?.toLowerCase().startsWith("fr")) {
            out = out.replaceAll(/œ/g, "oe").replaceAll(/æ/g, "ae").replaceAll(/Œ/g, "oe").replaceAll(/Æ/g, "ae");
        } else {
            out = out.normalize("NFKD").replaceAll(/\p{M}/gu, "");
        }

        out = out.replaceAll(/\s+/g, " ").trim();
        return out;
    }

    public static containsHtml(value: string): boolean {
        const parser = new DOMParser();
        const doc = parser.parseFromString(value, "text/html");

        return Array.from(doc.body.childNodes).some((node) => node.nodeType === Node.ELEMENT_NODE);
    }
}
